const CONTENT_RESULT_GROUPS: {
  type: GlobalSearch.ContentResultType;
  label: string;
}[] = [
  { type: 'dashboard', label: 'Dashboards' },
  { type: 'report', label: 'Reports' },
  { type: 'scorecard', label: 'KPI Lists' },
  { type: 'goal', label: 'Goals' },
  { type: 'board', label: 'Boards' },
  { type: 'workspace', label: 'Workspaces' },
  { type: 'app', label: 'Apps' },
];

const GLOBAL_SEARCH = {
  TOP_BAR_HEIGHT: 72,
  CONTENT_RESULT_GROUPS,
};

export default GLOBAL_SEARCH;
